export default __webpack_public_path__ + "static/media/img-4.4542c2da.jpg";